import { isClient } from './is';

export interface ConfigurableWindow {
  /*
   * Specify a custom `window` instance, e.g. working with iframes or in testing environments.
   */
  window?: Window;
}

export const defaultWindow = /* #__PURE__ */ isClient ? window : undefined;
export const defaultDocument = /* #__PURE__ */ isClient
  ? window.document
  : undefined;
export const defaultNavigator = /* #__PURE__ */ isClient
  ? window.navigator
  : undefined;
export const defaultLocation = /* #__PURE__ */ isClient
  ? window.location
  : undefined;
